const normalizeRoleName = (rawRole) => {
  const raw = (rawRole || '').trim();
  if (!raw) {
    return '';
  }
  const canonical = raw.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (canonical === 'SYSADMIN') {
    return 'SYS_ADMIN';
  }
  if (canonical === 'TENANTADMIN') {
    return 'TENANT_ADMIN';
  }
  if (canonical === 'TENANTUSER') {
    return 'TENANT_USER';
  }
  return raw.toUpperCase();
};

const normalizeTenantUserMode = (rawMode) => {
  const raw = (rawMode || '').trim();
  if (!raw) {
    return '';
  }
  const canonical = raw.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (canonical === 'READONLY') {
    return 'READONLY';
  }
  if (canonical === 'READWRITE') {
    return 'READ_WRITE';
  }
  return raw.toUpperCase();
};

const parseTokenPayload = () => {
  const token = sessionStorage.getItem('authToken');
  if (!token || !token.includes('.')) {
    return null;
  }
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch (_error) {
    return null;
  }
};

export const getAuthRole = () => {
  const storedRole = normalizeRoleName(sessionStorage.getItem('authRole'));
  if (storedRole) {
    return storedRole;
  }
  return normalizeRoleName(parseTokenPayload()?.role);
};

export const getTenantUserMode = () => {
  const storedMode = normalizeTenantUserMode(sessionStorage.getItem('authTenantUserMode'));
  if (storedMode) {
    return storedMode;
  }
  return normalizeTenantUserMode(parseTokenPayload()?.tenantUserMode);
};

export const isTenantAdminOrSystemAdmin = () => {
  const role = getAuthRole();
  return role === 'SYS_ADMIN' || role === 'TENANT_ADMIN';
};

export const isGlobalReadOnlyUser = () => {
  return false;
};

export const canUseWriteFeatures = () => {
  const role = getAuthRole();
  return role === 'SYS_ADMIN' || role === 'TENANT_ADMIN' || role === 'TENANT_USER';
};

export { normalizeRoleName, normalizeTenantUserMode };
